var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"btn btn--white",attrs:{"to":_vm.to,"tag":"button"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }